(ns app.agenda.register
  "UI register entries for the agenda slice."
  (:require [app.agenda.page :as page]
            [app.agenda.preview-modal :as preview-modal]))

(def register
  [page/page
   preview-modal/modal])
